import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../images/home-update/sub-bg-image.webp";
import { Link } from "gatsby";

function Subbanner() {
  return (
    <section
      className="tekrevol__sub overflow-x-hidden"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="banner-wrap text-center">
              <div
                className="example example-bottom center text-center"
                data-text="Discuss Project"
              >
                <h2>Gain Digital Edge, Accelerate Growth</h2>
              </div>
              <p>
                Don't miss out on this opportunity to transform your business
                idea into a reality. Whether you're just starting or looking to
                optimize your existing business, this workshop will give you the
                tools and insights you need.
                <br className="d-md-block d-none" />
              </p>
              <div className="btn-wrap text-center">
                <Link href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/" className="btn-pri">
                  Secure My Spot Today!
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Subbanner;
